<div class="row justify-content-center align-items-center" mat-dialog-title>
    <div class="col-md-10 col-10">
        <h5 class="text-left txt-primario">Lesionados</h5>
    </div>
    <div class="col-md-2 col-2 text-right">
        <i (click)="closeDialog('Cancelar')" class="fas fa-times icon-close"></i>
    </div>
</div>
<mat-dialog-content class="py-0">
    <div class="row">
        <div class="col-md-12 my-4 overflow-auto">
            <table mat-table multiTemplateDataRows [dataSource]="datoLesionados"
                class="table d-xl-table d-md-table d-sm-table table-responsive my-2">
                <ng-container matColumnDef="No">
                    <th mat-header-cell class="px-2" *matHeaderCellDef>No</th>
                    <td mat-cell *matCellDef="let element" class="mx-1">{{ element?.cve_registro}}</td>
                </ng-container>
                <ng-container matColumnDef="Nombre">
                    <th mat-header-cell class="px-2" *matHeaderCellDef>Nombre</th>
                    <td mat-cell *matCellDef="let element" class="mx-1">{{element?.nombre}}</td>
                </ng-container>

                <!-- Sin resultados -->
                <ng-container matColumnDef="noData">
                    <td mat-footer-cell *matFooterCellDef colspan="2">
                        <small>No se encontró ningún resultado</small>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayColumns;  sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayColumns;" (click)="seleccionarLesionado(row)"> </tr>
                <tr mat-footer-row *matFooterRowDef="['noData']"
                    [ngClass]="(datoLesionados?.data?.length === 0) ? '':'ocultarPaginator'"></tr>
            </table>

            <mat-paginator [pageSizeOptions]="[5, 10, 20, 50,100]" showFirstLastButtons
                aria-label="Select page of periodic elements">
            </mat-paginator>
        </div>
    </div>
</mat-dialog-content>